export const CLOSE_ALL_MODAL_EVENT = Symbol('CLOSE_MODAL_EVENT');
export const CLOSE_MODAL_BY_ID_EVENT = Symbol('CLOSE_MODAL_BY_ID_EVENT');
export const REMOVE_TALENT_FROM_COMPARISON_POPUP_EVENT = Symbol('REMOVE_TALENT_FROM_COMPARISON_POPUP_EVENT');
export const CLOSE_ALL_DRAWERS_EVENT = Symbol('CLOSE_ALL_DRAWERS_EVENT');
export const CLOSE_DRAWER_BY_ID_EVENT = Symbol('CLOSE_DRAWER_BY_ID_EVENT');
export const OPEN_CHAT_DRAWER_EVENT = Symbol('OPEN_CHAT_DRAWER_EVENT');
